import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CurrencyFormater } from 'quanta-flows';
import {
  faChevronCircleLeft,
  faUserTag,
  faCheck,
  faServer,
  faUsers,
  faFile,
  faEnvelope,
  faSpinner,
  faSms,
  faDownload,
  faUpload,
  faEdit,
  faPaperclip,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Card,
  TabbedDataGroup,
  Grid,
  GridItem,
  DataGrid,
  DataGridGroup,
  Paper,
  Button,
  CardWithPagination,
  Text,
  HideOnDesktop,
  useResponsiveParams,
  CircleButton,
  Label,
} from 'quanta-ui';
import {
  DOWNLOAD_FIRE_POLICY_PDF,
  SEND_POLICY_SMS_FIRE,
  SEND_POLICY_EMAIL_FIRE,
} from '../queries';
import { useMutationQuery } from 'quanta-flows';
import {ModalSendSms,} from 'quanta-flows/modules/common/modals';
import { ModalSendEmail} from 'quanta-flows/modules/common/modals';
import { QuantaConfigContext } from 'quanta-flows';
//import {TransactionComponent} from 'quanta-flows/modules/security';
import RiskLocationsPolicy from './risk-location-policy';

const reformData = (val, returnType) => {
  return val && val.toString().trim() !== '' ? val : returnType;
};

const renderSummaryData = (viewProposalSF, policy_no, history) => {
  const repeatForMobile = 2,
    repeatForDesktop = 3,
    repeatForIpad = 3;
 const repeat = useResponsiveParams({
    for_desktop: repeatForDesktop,
    for_mobile: repeatForMobile,
    for_iPad: repeatForIpad,
  });

  const name_info = (
    <Text type="heading" severity="info">
      {reformData('Zurich Kotak Bharat Griha Raksha', null)}
    </Text>
  );

  const back_button = (
    <div className="flex justify-end">
      <Button
        flat={true}
        size="small"
        onClick={(e) => history.goBack()}
      >
        <FontAwesomeIcon
          icon={faChevronCircleLeft}
          size="1x"
          className="cursor-pointer"
        />
        <span className="pl-1 text-xs">Back</span>
      </Button>
    </div>
  );

  return [
    { text: name_info, colSpan: repeatForMobile },
    { text: back_button },
    {
      label: 'Policy Number',
      text: reformData(policy_no, null),
    },
    {
      label: 'Policy Start Date',
      text: reformData(viewProposalSF?.startDate, null),
    },
    {
      label: 'Policy End Date',
      text: reformData(viewProposalSF?.endDate, null),
    },
    {
      label: 'Policy Type',
      text: reformData(viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover, null),
    },
  ];
};

const renderTabData = (
  viewProposalSF,
  customer,
  lobProductList,
  tableRepeat,
  branding,
  getDefaultWarranties,
  getDefaultClauses,
  getDefaultConditions,
  getDefaultExclusions,
) => {
  const repeatForMobile = 2,
    repeatForMobileAddOnCovers = 1,
    repeatForDesktop = 3,
    repeatForIpad = 3;
  const repeat = useResponsiveParams({
    for_desktop: repeatForDesktop,
    for_mobile: repeatForMobile,
  });

  const repeat1 = useResponsiveParams({
    for_desktop: 2,
    for_mobile: 3,
  });

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  const onMessage = () => {};

  return [
    {
      icon: <FontAwesomeIcon icon={faUserTag} />,
      label: 'Policy Details',
      tab_data: [
        {
          grid_data: [
            {
              label: 'Customer Number',
              text: reformData(customer.cust_number, null),
              //text: reformData(viewProposalSF.customerID, null),
            },
          ].filter((d) => d),
        },
        {
          title: `${
            customer.cust_type.value === 'Organisation'
              ? 'Organization Details'
              : 'Personal Details'
          }`,
          grid_data: [
            {
              label: (
                <div>
                  {customer.cust_type.value === 'Organisation'
                    ? 'Organization Name'
                    : 'Title'}
                </div>
              ),
              text: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation'
                    ? reformData(customer.org_detail.org_name, null)
                    : reformData(
                        customer.indv_detail.title.value,
                        null,
                      )}
                </div>
              ),
            },
            {
              label: (
                <div>
                  {customer.cust_type.value === 'Organisation'
                    ? 'Organization Type'
                    : 'Gender'}
                </div>
              ),
              text: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation'
                    ? reformData(
                        customer.org_detail.org_type.value,
                        null,
                      )
                    : reformData(
                        customer.indv_detail.gender.value,
                        null,
                      )}
                </div>
              ),
            },
            {
              label: (
                <div>
                  {customer.cust_type.value === 'Organisation'
                    ? 'Contact Name'
                    : 'Date of Birth'}
                </div>
              ),
              text: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation'
                    ? reformData(
                        customer.org_detail.contact_name,
                        null,
                      )
                    : reformData(
                        customer.indv_detail.date_of_birth,
                        null,
                      )}
                </div>
              ),
            },
            {
              label: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation'
                    ? 'Tan Number'
                    : 'First Name'}
                </div>
              ),
              text: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation'
                    ? reformData(customer.org_detail.tan_number, null)
                    : reformData(
                        customer.indv_detail.first_name,
                        null,
                      )}
                </div>
              ),
            },
            {
              label: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation'
                    ? 'Registration Number'
                    : 'Middle Name'}
                </div>
              ),
              text: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation' ? (
                    customer.org_detail.reg_number ? (
                      reformData(customer.org_detail.reg_number, null)
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : customer?.indv_detail?.middle_name ? (
                    reformData(
                      customer?.indv_detail?.middle_name,
                      null,
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
            {
              label: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation'
                    ? 'GST Number'
                    : 'Last Name'}
                </div>
              ),
              text: (
                <div className="mt-1">
                  {customer.cust_type.value === 'Organisation'
                    ? reformData(customer.org_detail.gst_number, null)
                    : reformData(customer.indv_detail.surname, null)}
                </div>
              ),
            },
          ].filter((d) => d),
        },
        {
          title: 'Identification Details',
          grid_data: [
            {
              label: 'Pan Card Number',
              text: (
                <div>
                  {customer.cust_type.value === 'Organisation' ? (
                    customer.org_detail.pan_card_number   /*CR 498  */
                    ? reformData(
                      customer.org_detail.pan_card_number,
                      null,
                    ): 
                    <Text severity="neutral">Not Captured</Text>
                  ) : (
                    reformData(
                      customer.indv_detail.pan_card_number,
                      null,
                    )
                  )}
                </div>
              ),
            },
            {
              label: 'Id Proof Type',
              text: (
                <div>
                  {customer.cust_type.value === 'Organisation' ? (
                    <Text severity="neutral">Not Captured</Text>
                  ) : (
                    reformData(
                      customer.indv_detail.id_proof_type.value,
                      null,
                    )
                  )}
                </div>
              ),
            },
            {
              label: 'Id Proof Number',
              text: (
                <div>
                  {customer.cust_type.value === 'Organisation' ? (
                    <Text severity="neutral">Not Captured</Text>
                  ) : (
                    reformData(
                      customer.indv_detail.id_proof_number,
                      null,
                    )
                  )}
                </div>
              ),
            },
          ].filter((d) => d),
        },
        {
          title: 'Permanent Address',
          grid_data: [
            {
              label: 'Address Line 1',
              text: reformData(
                customer.permanent_address.address_line1,
                null,
              ),
            },
            {
              label: 'Address Line 2',
              text: reformData(
                customer.permanent_address.address_line2,
                null,
              ),
            },
            {
              label: 'Address Line 3',
              text: reformData(
                customer.permanent_address.address_line3,
                null,
              ),
            },
            {
              label: 'Landmark',
              text: reformData(
                customer.permanent_address.land_mark,
                null,
              ),
            },
            {
              label: 'City/Town/Village',
              text: reformData(customer.permanent_address.city, null),
            },
            {
              label: 'Pincode',
              text: reformData(
                customer.permanent_address.pin_code,
                null,
              ),
            },
            {
              label: 'District',
              text: reformData(
                customer.permanent_address.district,
                null,
              ),
            },
            {
              label: 'State',
              text: reformData(
                customer.permanent_address.state,
                null,
              ),
            },
          ],
        },
        {
          title: 'Communication Address',
          grid_data: [
            {
              label: 'Address Line 1',
              text: (
                <div>
                  {customer.communication_address ? (
                    customer.communication_address.address_line1 ? (
                      reformData(
                        customer.communication_address.address_line1,
                        null,
                      )
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
            {
              label: 'Address Line 2',
              text: (
                <div>
                  {customer.communication_address ? (
                    customer.communication_address.address_line2 ? (
                      reformData(
                        customer.communication_address.address_line2,
                        null,
                      )
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
            {
              label: 'Address Line 3',
              text: (
                <div>
                  {customer.communication_address ? (
                    customer.communication_address.address_line3 ? (
                      reformData(
                        customer.communication_address.address_line3,
                        null,
                      )
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
            {
              label: 'Landmark',
              text: (
                <div>
                  {customer.communication_address ? (
                    customer.communication_address.land_mark ? (
                      reformData(
                        customer.communication_address.land_mark,
                        null,
                      )
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
            {
              label: 'City/Town/Village',
              text: (
                <div>
                  {customer.communication_address ? (
                    customer.communication_address.city ? (
                      reformData(
                        customer.communication_address.city,
                        null,
                      )
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
            {
              label: 'Pincode',
              text: (
                <div>
                  {customer.communication_address ? (
                    customer.communication_address.pin_code ? (
                      reformData(
                        customer.communication_address.pin_code,
                        null,
                      )
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
            {
              label: 'District',
              text: (
                <div>
                  {customer.communication_address ? (
                    customer.communication_address.district ? (
                      reformData(
                        customer.communication_address.district,
                        null,
                      )
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
            {
              label: 'State',
              text: (
                <div>
                  {customer.communication_address ? (
                    customer.communication_address.state ? (
                      reformData(
                        customer.communication_address.state,
                        null,
                      )
                    ) : (
                      <Text severity="neutral">Not Captured</Text>
                    )
                  ) : (
                    <Text severity="neutral">Not Captured</Text>
                  )}
                </div>
              ),
            },
          ],
        },
        {
          title: 'Contact & Email-Id',
          grid_data: [
            {
              label: 'Mobile Number',
              text: reformData(customer.contact.mobile, null),
            },
            {
              colSpan: repeat1,
              label: 'Email Id',
              text: reformData(customer.contact.email, null),
            },
          ],
        },
      ].filter((d) => d),
    },
    // {
    //   icon: <FontAwesomeIcon icon={faFile} />,
    //   label: 'Risk Details 1',
    //   tab_data: [
    //     {
    //       grid_data: [
    //         {
    //           label: 'Tenure',
    //           text: `${reformData(
    //             viewProposalSF?.tenure?.value,
    //             null,
    //           )}${
    //             viewProposalSF?.tenure?.value?.search('years') === -1
    //               ? ` year${
    //                   viewProposalSF?.tenure?.value === '1' ? '' : 's'
    //                 }`
    //               : ''
    //           }`,
    //         },
    //         {
    //           label: (
    //             <div className="mt-2">
    //               {repeat === repeatForDesktop
    //                 ? 'Annual Premium (inclusive of taxes)'
    //                 : 'Annual Premium'}
    //             </div>
    //           ),
    //           text: (
    //             <Text type="large">
    //               {CurrencyFormater(
    //                 reformData(
    //                   viewProposalSF.finalisedPremium.locTotalPremium,
    //                   null,
    //                 ),
    //                 true,
    //                 false,
    //                 branding,
    //                 true,
    //               )}
    //             </Text>
    //           ),
    //         },
    //       ],
    //     },
    //     {
    //       title: 'Risk Location Details',
    //       grid_data: [
    //         {
    //           colSpan: 3,
    //           label: '',
    //           text: (
                
    //               <RiskLocationsPolicy
    //                 viewProposalSF={viewProposalSF}
    //                 // goToStep
    //                 productName={viewProposalSF?.product?.productName}
    //               />
                
    //           ),
    //         },
    //       ],
    //     },
    //   ].filter((d) => d),
    // },    
    {
      icon: <FontAwesomeIcon icon={faUsers} />,
      label: 'Sum Insured Details',
      tab_data: [
        {
          title: 'Customer',
          grid_data: [
            {
              label: 'Occupancy Details',
              text: reformData(
                viewProposalSF?.ThirdGrid_Details?.Occupancy_Name,
                null,
              ),
            },
          ],
        },
        // viewProposalSF?.prevClaimExpDtls
        //   ? {
        //       title: 'Previous Claims Experience',
        //       grid_data: [
        //         {
        //           label: 'Previous Claims Experience Description',
        //           text: reformData(
        //             viewProposalSF?.prevClaimExpDtls?.prevClaimExpDesc,
        //             null,
        //           ),
        //         },
        //       ].filter((d) => d),
        //     }
        //   : null,

        {
          title: 'Policy Type',
          grid_data: [
            {
              label: 'Policy/Cover Type',
              text: reformData(viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover, null),
            },
          ].filter((d) => d),
        },
        viewProposalSF?.ThirdGrid_Details?.Building_Value
          ? {
              title: 'Insured Details',
              grid_data: [
                {
                  label: 'Building_Value',
                  text: reformData(
                    viewProposalSF?.ThirdGrid_Details?.Building_Value,
                    null,
                  ),
                },
                {
                  label: 'Cost Of Construction',
                  text: reformData(
                    viewProposalSF?.ThirdGrid_Details?.Cost_Of_Construction,
                    null,
                  ),
                },
                {
                  label: 'Carpet Area',
                  text: reformData(
                    viewProposalSF?.ThirdGrid_Details?.Carpet_Area,
                    null,
                  ),
                },
                {
                  label: 'General Content SI',
                  text: reformData(
                    viewProposalSF?.ThirdGrid_Details?.GeneralContentSI,
                    null,
                  ),
                },
                {
                  label: 'TotalBuilding Sum Insured',
                  text: reformData(
                    viewProposalSF?.ThirdGrid_Details?.TotalBuilding_Sum_Insured,
                    null,
                  ),
                },
                {
                  label: 'Total Content SI',
                  text: reformData(
                    viewProposalSF?.ThirdGrid_Details?.TotalContentSI,
                    null,
                  ),
                },
                {
                  label: 'Total SI',
                  text: reformData(
                    viewProposalSF?.ThirdGrid_Details?.Total_SI,
                    null,
                  ),
                },
              ].filter((d) => d),
            }
          : null,
      ],
    },
    // {
    //   icon: <FontAwesomeIcon icon={faServer} />,
    //   label: 'Additional Details',
    //   tab_data: [
    //     {
    //       title: 'Uploaded Documents',
    //       grid_data: [
    //         {
    //           colSpan: repeat,
    //           className: 'my-4',
    //           text:
    //             viewProposalSF?.uploadedDocuments &&
    //             viewProposalSF?.uploadedDocuments?.length > 0 &&
    //             viewProposalSF?.uploadedDocuments?.filter(
    //               (docDet) =>
    //                 docDet?.documentType?.code &&
    //                 docDet?.base64EncodedDoc,
    //             )?.length > 0 ? (
    //               viewProposalSF?.uploadedDocuments?.map(
    //                 (doc, idx) => {
    //                   return (
    //                     <Paper
    //                       key={idx}
    //                       className={`my-4 ${
    //                         idx === 0 ? '-mt-1' : ''
    //                       } bg-neutral-light border border-neutral p-4 rounded`}
    //                     >
    //                       <Grid
    //                         repeat={repeat}
    //                         gap={0}
    //                         gapX={0}
    //                         gapY={0}
    //                       >
    //                         <GridItem
    //                           colSpan={
    //                             screenType
    //                               ?.toString()
    //                               ?.toLowerCase() === 'mobile'
    //                               ? 2
    //                               : 2
    //                           }
    //                         >
    //                           <Text>
    //                             <Text>
    //                               <FontAwesomeIcon
    //                                 icon={faPaperclip}
    //                                 size="1x"
    //                                 className="mr-3"
    //                               />
    //                             </Text>
    //                             <Text
    //                               severity={'info'}
    //                               className={'font-semibold'}
    //                             >
    //                               {doc?.documentDescription &&
    //                               doc?.documentName
    //                                 ?.toString()
    //                                 ?.toLowerCase() === 'others'
    //                                 ? doc?.documentDescription
    //                                 : doc?.documentName}
    //                             </Text>
    //                             <Text
    //                               className={'flex flex-col ml-7'}
    //                               severity={'neutral-darker'}
    //                               type={'label'}
    //                             >
    //                               <Text
    //                                 className={
    //                                   'flex items-center flex-wrap'
    //                                 }
    //                               >
    //                                 <Text type={'label'}>
    //                                   File Name:&nbsp;
    //                                 </Text>
    //                                 <Text
    //                                   type={'label'}
    //                                   className={'break-normal'}
    //                                 >
    //                                   {doc?.documentName}
    //                                 </Text>
    //                               </Text>
    //                             </Text>
    //                             <Text
    //                               className={'flex flex-col ml-7'}
    //                               severity={'neutral-darker'}
    //                               type={'label'}
    //                             >
    //                               File Size:&nbsp;
    //                               {doc?.documentSize}
    //                             </Text>
    //                           </Text>
    //                         </GridItem>
    //                         <GridItem
    //                           colSpan={
    //                             screenType
    //                               ?.toString()
    //                               ?.toLowerCase() === 'mobile'
    //                               ? repeat
    //                               : 1
    //                           }
    //                           className={
    //                             'flex flex-col justify-center items-center'
    //                           }
    //                         >
    //                           <Text className="flex justify-center items-center">
    //                             <Button
    //                               type={'button'}
    //                               flat={true}
    //                               className="w-full md:w-56 md:pr-4 max-h-10 -ml-0.5"
    //                               onClick={(_) => {
    //                                 const downloadLink = document.createElement(
    //                                   'a',
    //                                 );
    //                                 const fileName =
    //                                   doc?.documentName;
    //                                 downloadLink.href =
    //                                   doc?.base64EncodedDoc;
    //                                 downloadLink.download = fileName;
    //                                 downloadLink.click();
    //                               }}
    //                               iconPre={
    //                                 <FontAwesomeIcon
    //                                   icon={faDownload}
    //                                 />
    //                               }
    //                             >
    //                               Download
    //                             </Button>
    //                           </Text>
    //                         </GridItem>
    //                       </Grid>
    //                     </Paper>
    //                   );
    //                 },
    //               )
    //             ) : (
    //               <div>No Documents Uploaded</div>
    //             ),
    //         },
    //       ].filter((d) => d),
    //     },
    //     {
    //       grid_data: [
    //         getDefaultClauses?.length > 0 ||
    //         viewProposalSF?.clauses?.userDefined?.length > 0
    //           ? {
    //               label: '',
    //               colSpan: repeat,
    //               className: 'my-4',
    //               text: (
    //                 <div>
    //                   <Paper
    //                     className={`mt-1 mb-1 bg-neutral-light border border-neutral p-4 rounded`}
    //                   >
    //                     {getDefaultClauses &&
    //                     getDefaultClauses?.length > 0 ? (
    //                       <div>
    //                         <Text type="title" className="ml-1 mt-3">
    //                           Default Clauses
    //                         </Text>
    //                         {getDefaultClauses?.map((clause, idx) => {
    //                           return (
    //                             <ul
    //                               key={idx}
    //                               className="list-disc ml-6 mt-2 font-normal"
    //                             >
    //                               <li key={idx}>
    //                                 {clause?.clauseDescription}
    //                               </li>
    //                             </ul>
    //                           );
    //                         })}
    //                       </div>
    //                     ) : null}
    //                     {viewProposalSF?.clauses?.userDefined &&
    //                     viewProposalSF?.clauses?.userDefined?.length >
    //                       0 ? (
    //                       <div className="ml-1 mt-3">
    //                         <Text type="title" className="ml-1 mt-3">
    //                           User Defined Clauses
    //                         </Text>
    //                         <ul className="list-disc ml-6 mt-4 font-normal">
    //                           {viewProposalSF?.clauses?.userDefined?.map(
    //                             (clause, idx) => (
    //                               <li key={idx}>{clause}</li>
    //                             ),
    //                           )}
    //                         </ul>
    //                       </div>
    //                     ) : null}
    //                   </Paper>
    //                 </div>
    //               ),
    //             }
    //           : null,
    //         getDefaultConditions?.length > 0 ||
    //         viewProposalSF?.conditions?.userDefined?.length > 0
    //           ? {
    //               label: '',
    //               colSpan: repeat,
    //               className: 'my-4',
    //               text: (
    //                 <div>
    //                   <Paper
    //                     className={`mt-1 mb-1 bg-neutral-light border border-neutral p-4 rounded`}
    //                   >
    //                     {getDefaultConditions &&
    //                     getDefaultConditions?.length > 0 ? (
    //                       <div>
    //                         <Text type="title" className="ml-1 mt-3">
    //                           Default Conditions
    //                         </Text>
    //                         {getDefaultConditions?.map(
    //                           (condition, idx) => {
    //                             return (
    //                               <ul
    //                                 key={idx}
    //                                 className="list-disc ml-6 mt-2 font-normal"
    //                               >
    //                                 <li key={idx}>
    //                                   {
    //                                     condition?.conditionShortDescription
    //                                   }
    //                                 </li>
    //                               </ul>
    //                             );
    //                           },
    //                         )}
    //                       </div>
    //                     ) : null}
    //                     {viewProposalSF?.conditions?.userDefined &&
    //                     viewProposalSF?.conditions?.userDefined
    //                       ?.length > 0 ? (
    //                       <div className="ml-1 mt-3">
    //                         <Text type="title" className="ml-1 mt-3">
    //                           User Defined Conditions
    //                         </Text>
    //                         <ul className="list-disc ml-6 mt-4 font-normal">
    //                           {viewProposalSF?.conditions?.userDefined?.map(
    //                             (condition, idx) => (
    //                               <li key={idx}>{condition}</li>
    //                             ),
    //                           )}
    //                         </ul>
    //                       </div>
    //                     ) : null}
    //                   </Paper>
    //                 </div>
    //               ),
    //             }
    //           : null,
    //         getDefaultExclusions?.length > 0 ||
    //         viewProposalSF?.exclusions?.userDefined?.length > 0
    //           ? {
    //               label: '',
    //               colSpan: repeat,
    //               className: 'my-4',
    //               text: (
    //                 <div>
    //                   <Paper
    //                     className={`mt-1 mb-1 bg-neutral-light border border-neutral p-4 rounded`}
    //                   >
    //                     {getDefaultExclusions &&
    //                     getDefaultExclusions?.length > 0 ? (
    //                       <div>
    //                         <Text type="title" className="ml-1 mt-3">
    //                           Default Exclusions
    //                         </Text>
    //                         {getDefaultExclusions?.map(
    //                           (exclusion, idx) => {
    //                             return (
    //                               <ul
    //                                 key={idx}
    //                                 className="list-disc ml-6 mt-2 font-normal"
    //                               >
    //                                 <li key={idx}>
    //                                   {
    //                                     exclusion?.exclusionShortDescription
    //                                   }
    //                                 </li>
    //                               </ul>
    //                             );
    //                           },
    //                         )}
    //                       </div>
    //                     ) : null}
    //                     {viewProposalSF?.exclusions?.userDefined &&
    //                     viewProposalSF?.exclusions?.userDefined
    //                       ?.length > 0 ? (
    //                       <div className="ml-1 mt-3">
    //                         <Text type="title" className="ml-1 mt-3">
    //                           User Defined Exclusions
    //                         </Text>
    //                         <ul className="list-disc ml-6 mt-4 font-normal">
    //                           {viewProposalSF?.exclusions?.userDefined?.map(
    //                             (exclusion, idx) => (
    //                               <li key={idx}>{exclusion}</li>
    //                             ),
    //                           )}
    //                         </ul>
    //                       </div>
    //                     ) : null}
    //                   </Paper>
    //                 </div>
    //               ),
    //             }
    //           : null,
    //         getDefaultWarranties?.length > 0 ||
    //         viewProposalSF?.warranties?.userDefined?.length > 0
    //           ? {
    //               label: '',
    //               colSpan: repeat,
    //               className: 'my-4',
    //               text: (
    //                 <div>
    //                   <Paper
    //                     className={`mt-1 mb-1 bg-neutral-light border border-neutral p-4 rounded`}
    //                   >
    //                     {getDefaultWarranties &&
    //                     getDefaultWarranties?.length > 0 ? (
    //                       <div>
    //                         <Text type="title" className="ml-1 mt-3">
    //                           Default Warranties
    //                         </Text>
    //                         {getDefaultWarranties?.map(
    //                           (warranty, idx) => {
    //                             return (
    //                               <ul
    //                                 key={idx}
    //                                 className="list-disc ml-6 mt-2 font-normal"
    //                               >
    //                                 <li key={idx}>
    //                                   {
    //                                     warranty?.warrantyShortDescription
    //                                   }
    //                                 </li>
    //                               </ul>
    //                             );
    //                           },
    //                         )}
    //                       </div>
    //                     ) : null}
    //                     {viewProposalSF?.warranties?.userDefined &&
    //                     viewProposalSF?.warranties?.userDefined
    //                       ?.length > 0 ? (
    //                       <div className="ml-1 mt-3">
    //                         <Text type="title" className="ml-1 mt-3">
    //                           User Defined Warranties
    //                         </Text>
    //                         <ul className="list-disc ml-6 mt-4 font-normal">
    //                           {viewProposalSF?.warranties?.userDefined?.map(
    //                             (warranty, idx) => (
    //                               <li key={idx}>{warranty}</li>
    //                             ),
    //                           )}
    //                         </ul>
    //                       </div>
    //                     ) : null}
    //                   </Paper>
    //                 </div>
    //               ),
    //             }
    //           : null,
    //         viewProposalSF?.underwriterComment &&
    //         viewProposalSF?.underwriterComment?.length > 0
    //           ? {
    //               label: '',
    //               colSpan: repeat,
    //               className: 'my-4',
    //               text: (
    //                 <div>
    //                   <Paper
    //                     className={`mt-1 mb-1 bg-neutral-light border border-neutral p-4 rounded`}
    //                   >
    //                     {viewProposalSF?.underwriterComment &&
    //                     viewProposalSF?.underwriterComment?.length >
    //                       0 ? (
    //                       <div className="flex flex-col ml-1 mt-2">
    //                         <Text type="title" className="ml-1 mt-3">
    //                           Underwriter Comments
    //                         </Text>
    //                         <div className="ml-1 mt-2">
    //                           {viewProposalSF?.underwriterComment}
    //                         </div>
    //                       </div>
    //                     ) : null}
    //                   </Paper>
    //                 </div>
    //               ),
    //             }
    //           : null,
    //       ].filter((d) => d),
    //     },
    //   ].filter((d) => d),
    // },
  ];
};

export default function ViewPolicyDetailsFire({
  viewProposalSF,
  policy_no,
  customer_id,
  proposal_no,
  customer,
  lobProductList,
  myIntermediaries,
  getDefaultWarranties,
  getDefaultClauses,
  getDefaultConditions,
  getDefaultExclusions,
}) {
  const history = useHistory();
  const tableRepeat = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3,
  });
  const { branding } = useContext(QuantaConfigContext);

  const getBase64VarForFire = (
    viewProposalSF,
    customer,
    policy_no,
  ) => {
    return {
      input: {
        intermediary: {
          intermediaryCode: viewProposalSF?.intermediaryDetails?.code
            ? `${viewProposalSF?.intermediaryDetails?.code}`
            : '',
          locationCode: viewProposalSF?.intermediaryDetails?.location
            ? `${viewProposalSF?.intermediaryDetails?.location}`
            : '',
          fieldUserCode: viewProposalSF?.intermediaryDetails
            ?.fieldUserCode
            ? `${viewProposalSF?.intermediaryDetails?.fieldUserCode}`
            : `${viewProposalSF?.intermediaryDetails?.fieldUserName}`,
        },

        lob: viewProposalSF?.lob?.lobCode,
        product: viewProposalSF?.product?.productCode
          ? `${viewProposalSF?.product?.productCode}`
          : '',

        customer: {
          id: customer?.cust_number ? `${customer?.cust_number}` : '',
          customerType: customer?.cust_type?.code
            ? `${customer?.cust_type?.code}`
            : '',
          title: customer?.indv_detail?.title?.code
            ? `${customer?.indv_detail?.title?.code}`
            : '',
          gender: customer?.indv_detail?.gender?.code
            ? `${customer?.indv_detail?.gender?.code}`
            : '',
          firstName: customer?.indv_detail?.first_name
            ? `${customer?.indv_detail?.first_name}`
            : '',
          middleName: customer?.indv_detail?.middle_name
            ? `${customer?.indv_detail?.middle_name}`
            : '',
          lastName: customer?.indv_detail?.surname
            ? `${customer?.indv_detail?.surname}`
            : '',
          fullName: customer?.indv_detail?.full_name
            ? `${customer?.indv_detail?.full_name}`
            : '',
          maritalStatus: customer?.indv_detail?.marital_status?.code
            ? `${customer?.indv_detail?.marital_status?.code}`
            : '',
          occupation: customer?.indv_detail?.occupation?.code
            ? `${customer?.indv_detail?.occupation?.code}`
            : '',
          nationality: customer?.indv_detail?.nationality?.code
            ? `${customer?.indv_detail?.nationality?.code}`
            : '',
          proposerDOB: customer?.indv_detail?.date_of_birth
            ? `${customer?.indv_detail?.date_of_birth}`
            : '',
          panNumber: customer?.indv_detail?.pan_card_number
            ? `${customer?.indv_detail?.pan_card_number}`
            : customer?.org_detail?.pan_card_number     /*CR 498  */
            ? `${customer?.org_detail?.pan_card_number}`
            : '',
          idProofType: customer?.indv_detail?.id_proof_type?.code
            ? `${customer?.indv_detail?.id_proof_type?.code}`
            : '',
          idProofNumber: customer?.indv_detail?.id_proof_number
            ? `${customer?.indv_detail?.id_proof_number}`
            : '',
          permAddressLine1: customer?.permanent_address?.address_line1
            ? `${customer?.permanent_address?.address_line1}`
            : '',
          permAddressLine2: customer?.permanent_address?.address_line2
            ? `${customer?.permanent_address?.address_line2}`
            : '',
          permAddressLine3: customer?.permanent_address?.address_line3
            ? `${customer?.permanent_address?.address_line3}`
            : '',
          permLandmark: customer?.permanent_address?.land_mark
            ? `${customer?.permanent_address?.land_mark}`
            : '',
          permPincode: customer?.permanent_address?.pin_code
            ? `${customer?.permanent_address?.pin_code}`
            : '',
          permCityTownVillage: customer?.permanent_address?.city
            ? `${customer?.permanent_address?.city}`
            : '',
          permDistrict: customer?.permanent_address?.district
            ? `${customer?.permanent_address?.district}`
            : '',
          permState: customer?.permanent_address?.state
            ? `${customer?.permanent_address?.state}`
            : '',
          permCommAddressYN: customer?.comm_equal_perm ? true : false,
          commAddressLine1: customer?.communication_address
            ?.address_line1
            ? `${customer?.communication_address?.address_line1}`
            : '',
          commAddressLine2: customer?.communication_address
            ?.address_line2
            ? `${customer?.communication_address?.address_line2}`
            : '',
          commAddressLine3: customer?.communication_address
            ?.address_line3
            ? `${customer?.communication_address?.address_line3}`
            : '',
          commLandmark: customer?.communication_address.land_mark
            ? `${customer?.communication_address?.land_mark}`
            : '',
          commPincode: customer?.communication_address?.pin_code
            ? `${customer?.communication_address?.pin_code}`
            : '',
          commCityTownVillage: customer?.communication_address?.city
            ? `${customer?.communication_address?.city}`
            : '',
          commDistrict: customer?.communication_address?.district
            ? `${customer?.communication_address?.district}`
            : '',
          commState: customer?.communication_address?.state
            ? `${customer?.communication_address?.state}`
            : '',
          phoneNo: customer?.contact?.telephone
            ? `${customer?.contact?.telephone}`
            : '',
          mobileNo:
            customer?.contact?.mobile ||
            customer?.org_detail?.contact_mob
              ? `${
                  customer?.contact?.mobile ||
                  customer?.org_detail?.contact_mob
                }`
              : '',
          emailID:
            customer?.contact?.email ||
            customer?.org_detail?.contact_email
              ? `${
                  customer?.contact?.email ||
                  customer?.org_detail?.contact_email
                }`
              : '',
          faxNo: customer?.contact?.fax_number
            ? `${customer?.contact?.fax_number}`
            : '',
          altPhoneNo: customer?.contact?.alt_telephone
            ? `${customer?.contact?.alt_telephone}`
            : '',
          altMobileNo: customer?.contact?.alt_mobile
            ? `${customer?.contact?.alt_mobile}`
            : '',
          orgName: customer?.org_detail?.org_name
            ? `${customer?.org_detail?.org_name}`
            : '',
          orgType: customer?.org_detail?.org_type?.code
            ? `${customer?.org_detail?.org_type?.code}`
            : '',
          contactName: customer?.org_detail?.contact_name
            ? `${customer?.org_detail?.contact_name}`
            : '',
          regNumber: customer?.org_detail?.reg_number
            ? `${customer?.org_detail?.reg_number}`
            : '',
          tanNumber: customer?.org_detail?.tan_number
            ? `${customer?.org_detail?.tan_number}`
            : '',
          gstNumber:
            customer?.org_detail?.gst_number ||
            customer?.indv_detail?.gst_number
              ? `${
                  customer?.org_detail?.gst_number ||
                  customer?.indv_detail?.gst_number
                }`
              : '',
          ifscCode: customer?.bank_detail?.ifsc_code
            ? `${customer?.bank_detail?.ifsc_code}`
            : '',
          bankName: customer?.bank_detail?.name
            ? `${customer?.bank_detail?.name}`
            : '',
          branchName: customer?.bank_detail?.branch_name
            ? `${customer?.bank_detail?.branch_name}`
            : '',
          bankAcno: customer?.bank_detail?.acc_number
            ? `${customer?.bank_detail?.acc_number}`
            : '',
          accountHolderName: customer?.bank_detail?.acc_holder
            ? `${customer?.bank_detail?.acc_holder}`
            : '',
          micrCode: customer?.bank_detail?.micr_code
            ? `${customer?.bank_detail?.micr_code}`
            : '',
          employeeNumber: customer?.indv_detail?.employeeNumber
            ? `${customer?.indv_detail?.employeeNumber}`
            : '',
          isThinCustomer: false,
        },

        businessOfInsured: viewProposalSF?.businessOfInsured
          ? `${viewProposalSF?.businessOfInsured}`
          : '',
        anyPrevClaimsExp:
          viewProposalSF?.prevClaimExpDtls?.anyPrevClaimsExp === true
            ? true
            : false,
        prevClaimExpDesc: viewProposalSF?.prevClaimExpDtls
          ?.prevClaimExpDesc
          ? `${viewProposalSF?.prevClaimExpDtls?.prevClaimExpDesc}`
          : '',
        isKutchaConstruct:
          viewProposalSF?.isKutchaConstruct === true ? true : false,
        policyType: viewProposalSF?.policyType
          ? `${viewProposalSF?.policyType}`
          : '',
        quoteNumber: viewProposalSF?.quoteNumber
          ? `${viewProposalSF?.quoteNumber}`
          : '',

        tenure: viewProposalSF?.tenure?.value
          ? `${viewProposalSF?.tenure?.value}`
          : '',
        policyStartDate: viewProposalSF?.policyStartDate,

        riskLocations:
          viewProposalSF?.policyType?.toString()?.toLowerCase() ===
          'non floater'
            ? viewProposalSF?.riskLocations?.map((riskLoc) => {
                return {
                  quoteNumber: viewProposalSF?.quoteNumber,
                  riskLocationID: riskLoc?.riskLocationID,
                  occupancyCodeValue: {
                    code: riskLoc?.occupancyCodeValue?.code,
                    value: riskLoc?.occupancyCodeValue?.value,
                    occupancySection:
                      riskLoc?.occupancyCodeValue?.occupancySection,
                    occupancyRate:
                      riskLoc?.occupancyCodeValue?.occupancyRate,
                    riskCode: riskLoc?.occupancyCodeValue?.riskCode,
                    rateCode: riskLoc?.occupancyCodeValue?.rateCode,
                    riskGrade: riskLoc?.occupancyCodeValue?.riskGrade,
                    riskGradeDefinition:
                      riskLoc?.occupancyCodeValue
                        ?.riskGradeDefinition,
                    riskPreference:
                      riskLoc?.occupancyCodeValue?.riskPreference,
                    gicClass: riskLoc?.occupancyCodeValue?.gicClass,
                    stfiRate: riskLoc?.occupancyCodeValue?.stfiRate,
                    rsmdRate: riskLoc?.occupancyCodeValue?.rsmdRate,
                  },
                  riskLocAddress: {
                    addressLine1:
                      riskLoc?.riskLocAddress?.address_line1,
                    addressLine2:
                      riskLoc?.riskLocAddress?.address_line2,
                    addressLine3:
                      riskLoc?.riskLocAddress?.address_line3,
                    landmark: riskLoc?.riskLocAddress?.land_mark,
                    pinCode: riskLoc?.riskLocAddress?.pin_code.replace(
                      ' ',
                      '',
                    ),
                    state: riskLoc?.riskLocAddress?.state,
                    city: riskLoc?.riskLocAddress?.city,
                    district: riskLoc?.riskLocAddress?.district,
                    zone: riskLoc?.riskLocAddress?.zone,
                    eqZone: riskLoc?.riskLocAddress?.eqZone,
                    locationCode:
                      riskLoc?.riskLocAddress?.locationCode,
                    isSamePremises: false,
                    allIndiaBasisDesc:
                      riskLoc?.riskLocAddress?.allIndiaBasisDesc,
                  },

                  buildingSI: riskLoc?.buildingSI,
                  plantMachinerySI: riskLoc?.plantMachinerySI,
                  furnitureFixtureSI: riskLoc?.furnitureFixtureSI,
                  rawMaterialSI: riskLoc?.rawMaterialSI,
                  otherContentsSI: riskLoc?.otherContentsSI,
                  stocksSI: riskLoc?.stocksSI,
                  stocksInProcessSI: riskLoc?.stocksInProcessSI,

                  fireExtinguishApplisDtls: riskLoc?.fireExtinguishApplisDtls?.map(
                    (fire) => {
                      return {
                        applianceCode: fire?.value,
                        isSelected: fire?.selected,
                      };
                    },
                  ),
                  constructionClass: riskLoc?.constructionClass,
                  waterbodyDistance: riskLoc?.waterbodyDistance,
                  securityProvisions: riskLoc?.securityProvisions,
                  loadingPct: riskLoc?.loadingPct,
                  discountPct: riskLoc?.discountPct,
                  prevClaimExpDesc: riskLoc?.prevClaimExpDesc,

                  premium: {
                    locNetPremium:
                      riskLoc?.premium?.locationNetPremium,
                    locGST: riskLoc?.premium?.locationGST,
                    locTotalPremium:
                      riskLoc?.premium?.locationTotalPremium,
                    stampDuty: riskLoc?.premium?.stampDuty,
                  },
                };
              })
            : viewProposalSF?.policyType
                ?.toString()
                ?.toLowerCase() === 'floater'
            ? viewProposalSF?.riskLocations?.map((fireData) => {
                return {
                  quoteNumber: viewProposalSF?.quoteNumber,
                  riskLocationID: fireData?.riskLocationID,

                  occupancyCodeValue: {
                    code: fireData?.occupancyCodeValue?.code,
                    value: fireData?.occupancyCodeValue?.value,
                    occupancySection:
                      fireData?.occupancyCodeValue?.occupancySection,
                    occupancyRate:
                      fireData?.occupancyCodeValue?.occupancyRate,
                    riskCode: fireData?.occupancyCodeValue?.riskCode,
                    rateCode: fireData?.occupancyCodeValue?.rateCode,
                    riskGrade:
                      fireData?.occupancyCodeValue?.riskGrade,
                    riskGradeDefinition:
                      fireData?.occupancyCodeValue
                        ?.riskGradeDefinition,
                    riskPreference:
                      fireData?.occupancyCodeValue?.riskPreference,
                    gicClass: fireData?.occupancyCodeValue?.gicClass,
                    stfiRate: fireData?.occupancyCodeValue?.stfiRate,
                    rsmdRate: fireData?.occupancyCodeValue?.rsmdRate,
                  },
                  riskLocAddress: {
                    addressLine1: '',
                    addressLine2: '',
                    addressLine3: '',
                    landmark: '',
                    pinCode: '',
                    state: '',
                    city: '',
                    district: '',
                    zone: '',
                    eqZone: '',
                    locationCode: '',
                    isSamePremises: false,
                    allIndiaBasisDesc: '',
                  },
                  buildingSI: fireData?.buildingSI,
                  plantMachinerySI: fireData?.plantMachinerySI,
                  furnitureFixtureSI: fireData?.furnitureFixtureSI,
                  rawMaterialSI: fireData?.rawMaterialSI,
                  otherContentsSI: fireData?.otherContentsSI,
                  stocksSI: fireData?.stockSI,
                  stocksInProcessSI: fireData?.stocksInProcessSI,
                  stockOnFloaterBasis: fireData?.stockOnFloaterBasis,
                  floaterLocations: fireData?.floaterLocations.map(
                    (floatLoc) => {
                      return {
                        addressLine1: floatLoc?.address_line1,
                        pinCode: floatLoc?.pin_code.replace(' ', ''),
                        state: floatLoc?.state,
                        city: floatLoc?.city,
                        district: floatLoc?.district,
                        zone: floatLoc?.zone,
                        eqZone: floatLoc?.eqZone,
                        locationCode: floatLoc?.locationCode,
                      };
                    },
                  ),
                  maxStockSIAtOneLoc: fireData?.maxStockSIAtOneLoc,
                  fireExtinguishApplisDtls: fireData?.fireExtinguisherAppliancesDetails?.map(
                    (fire) => {
                      return {
                        applianceCode: fire?.value,
                        isSelected: fire?.selected,
                      };
                    },
                  ),
                  constructionClass: fireData?.constructionClass,
                  waterbodyDistance: fireData?.waterbodyDistance,
                  securityProvisions: fireData?.securityProvisions,

                  loadingPct: fireData?.loadingPct,
                  discountPct: fireData?.discountPct,
                  prevClaimExpDesc: fireData?.prevClaimExpDesc,

                  premium: {
                    locNetPremium:
                      fireData?.premium?.locationNetPremium,
                    locGST: fireData?.premium?.locationGST,
                    locTotalPremium:
                      fireData?.premium?.locationTotalPremium,
                    stampDuty: fireData?.premium?.stampDuty,
                  },
                };
              })
            : {},
        policyStartDate: viewProposalSF?.policyStartDate
          ? `${viewProposalSF?.policyStartDate}`
          : '',

        clauses: {
          default: viewProposalSF?.clauses?.default.map((data) => {
            return data;
          }),
          userDefined: viewProposalSF?.clauses?.userDefined.map(
            (data) => {
              return data;
            },
          ),
        },
        warranties: {
          default: viewProposalSF?.warranties?.default.map((data) => {
            return data;
          }),
          userDefined: viewProposalSF?.warranties?.userDefined.map(
            (data) => {
              return data;
            },
          ),
        },
        conditions: {
          default: viewProposalSF?.conditions?.default.map((data) => {
            return data;
          }),
          userDefined: viewProposalSF?.conditions?.userDefined.map(
            (data) => {
              return data;
            },
          ),
        },
        exclusions: {
          default: viewProposalSF?.exclusions?.default.map((data) => {
            return data;
          }),
          userDefined: viewProposalSF?.exclusions?.userDefined.map(
            (data) => {
              return data;
            },
          ),
        },

        finalisedPremium: {
          locNetPremium: viewProposalSF?.finalisedPremium
            ?.locNetPremium
            ? viewProposalSF?.finalisedPremium?.locNetPremium
            : 0,
          locGST: viewProposalSF?.finalisedPremium?.locGST
            ? viewProposalSF?.finalisedPremium?.locGST
            : 0,
          locTotalPremium: viewProposalSF?.finalisedPremium
            ?.locTotalPremium
            ? viewProposalSF?.finalisedPremium?.locTotalPremium
            : 0,
          stampDuty: viewProposalSF?.finalisedPremium?.stampDuty
            ? viewProposalSF?.finalisedPremium?.stampDuty
            : 0,
        },
        financierDtls: {
          financerName: viewProposalSF?.financierDtls?.financerName,
          financerAddress:
            viewProposalSF?.financierDtls?.financerAddress,
          financerAgreementType:
            viewProposalSF?.financierDtls?.financerAgreementType,
          loanAccountNumber:
            viewProposalSF?.financierDtls?.loanAccountNumber,
          FileNumber: viewProposalSF?.financierDtls?.fileNumber,
        },

        uploadDocuments:
          viewProposalSF?.uploadedDocuments &&
          viewProposalSF?.uploadedDocuments?.length > 0
            ? viewProposalSF?.uploadedDocuments?.map((uploadDet) => {
                return {
                  documentType: {
                    code: uploadDet?.documentType?.code,
                    value: uploadDet?.documentType?.value,
                  },
                  documentName: uploadDet?.documentName,
                  documentSize: uploadDet?.documentSize,
                  base64EncodedDoc: uploadDet?.base64EncodedDoc,
                };
              })
            : [],
      },
    };
  };

  const [loadingDownload, setLoadingDownload] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [showSms, setShowSms] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const mutateQuery = useMutationQuery();

  const stickybar = [
    {
      text: (
        <div className="flex justify-center">
          <CircleButton
            size="medium"
            onClick={(e) => setShowEmail(true)}
          >
            <FontAwesomeIcon icon={faEnvelope} size="2x" />
          </CircleButton>
        </div>
      ),
    },
    {
      text: (
        <div className="flex justify-center">
          <CircleButton
            size="medium"
            onClick={(e) => setShowSms(true)}
          >
            <FontAwesomeIcon icon={faSms} size="2x" />
          </CircleButton>
        </div>
      ),
    },
    {
      text: (
        <div className="flex justify-center">
          <CircleButton
            size="medium"
            onClick={async (_) => {
              try {
                setLoadingDownload(true);
                let policyPDFBase64String = mutateQuery({
                  mutation: DOWNLOAD_FIRE_POLICY_PDF,
                  variables: getBase64VarForFire(
                    viewProposalSF,
                    customer,
                    policy_no,
                  ),
                });
                let {
                  data: dataBase64String,
                } = await policyPDFBase64String;
                const { downloadPolicyPDFFire } = dataBase64String;
                const {
                  base64Pdf: downloadBase64String,
                } = downloadPolicyPDFFire;
                setLoadingDownload(false);

                let byteCharacters = atob(
                  downloadBase64String.toString(),
                );
                let byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                let byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], {
                  type: 'application/pdf;base64',
                });
                let fileURL = URL.createObjectURL(file);
                window.open(fileURL);
              } catch (error) {
                setAlerts([
                  {
                    id: Date.now(),
                    content: (
                      <div className="flex flex-col w-full h-full">
                        <Text type="normal">{error.message}</Text>
                      </div>
                    ),
                    type: 'error',
                    timeout: null,
                    disableClose: false,
                  },
                ]);
                setLoadingDownload(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
          >
            <FontAwesomeIcon
              icon={loadingDownload ? faSpinner : faDownload}
              spin={loadingDownload}
              size="2x"
            />
          </CircleButton>
        </div>
      ),
    },
    {
      text: (
        <div className="flex justify-center">
          <CircleButton
            size="medium"
            onClick={() => {
              if (
                sessionStorage
                  ?.getItem('intermediaryCode')
                  ?.toString()
                  ?.toLowerCase() !==
                viewProposalSF?.intermediaryDetails?.code
                  ?.toString()
                  ?.toLowerCase()
              ) {
                sessionStorage?.setItem('fieldUserCode', '');
                sessionStorage?.setItem('fieldUserName', '');
              }
              sessionStorage?.setItem(
                'intermediaryCode',
                viewProposalSF?.intermediaryDetails?.code,
              );
              sessionStorage?.setItem(
                'intermediaryName',
                myIntermediaries?.find(
                  (imd) =>
                    imd?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                    viewProposalSF?.intermediaryDetails?.code
                      ?.toString()
                      ?.toLowerCase(),
                )?.intermediaryName,
              );
              sessionStorage?.setItem(
                'branchOfficeCode',
                myIntermediaries?.find(
                  (imd) =>
                    imd?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                    viewProposalSF?.intermediaryDetails?.code
                      ?.toString()
                      ?.toLowerCase(),
                )?.businessLocations &&
                  myIntermediaries?.find(
                    (imd) =>
                      imd?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                      viewProposalSF?.intermediaryDetails?.code
                        ?.toString()
                        ?.toLowerCase(),
                  )?.businessLocations?.length > 0
                  ? myIntermediaries?.find(
                      (imd) =>
                        imd?.intermediaryCode
                          ?.toString()
                          ?.toLowerCase() ===
                        viewProposalSF?.intermediaryDetails?.code
                          ?.toString()
                          ?.toLowerCase(),
                    )?.businessLocations[0]?.code
                  : '',
              );
              sessionStorage?.setItem(
                'branchOfficeName',
                myIntermediaries?.find(
                  (imd) =>
                    imd?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                    viewProposalSF?.intermediaryDetails?.code
                      ?.toString()
                      ?.toLowerCase(),
                )?.businessLocations &&
                  myIntermediaries?.find(
                    (imd) =>
                      imd?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                      viewProposalSF?.intermediaryDetails?.code
                        ?.toString()
                        ?.toLowerCase(),
                  )?.businessLocations?.length > 0
                  ? myIntermediaries?.find(
                      (imd) =>
                        imd?.intermediaryCode
                          ?.toString()
                          ?.toLowerCase() ===
                        viewProposalSF?.intermediaryDetails?.code
                          ?.toString()
                          ?.toLowerCase(),
                    )?.businessLocations[0]?.name
                  : '',
              );
              history.push(`/upload-documents/policy/${policy_no}`);
            }}
          >
            <FontAwesomeIcon icon={faUpload} size="2x" />
          </CircleButton>
        </div>
      ),
    },
    {
      text: (
        <div className="flex justify-center">
          //<TransactionComponent>
            <CircleButton
              size="medium"
              onClick={() => {
                window?.scrollTo({
                  top: 0,
                  behavior: 'smooth',
                });
                history.push(
                  `/policy/endorse/${customer_id}/${viewProposalSF?.product?.productCode}/${viewProposalSF?.product?.productName}/${proposal_no}`,
                );
              }}
            >
              <FontAwesomeIcon icon={faEdit} size="2x" />
            </CircleButton>
          //</TransactionComponent>
        </div>
      ),
    },
  ].filter((d) => d);

  return (
    <>
      <div className="w-full">
        <Card title="View Policy Details" className="min-h-screen">
          <>
            <div className="p-0 pt-4 pb-8">
              <DataGrid
                textType="normal"
                data={renderSummaryData(
                  viewProposalSF,
                  policy_no,
                  history,
                )}
                nullData={() => (
                  <Text severity="neutral">Not Captured</Text>
                )}
              />
            </div>
            <TabbedDataGroup
              data={renderTabData(
                viewProposalSF,
                customer,
                lobProductList,
                tableRepeat,
                branding,
                getDefaultWarranties,
                getDefaultClauses,
                getDefaultConditions,
                getDefaultExclusions,
              )}
              textType="normal"
              titleSeverity="info"
              repeat={tableRepeat}
              nullData={() => (
                <Text severity="neutral">Not Captured</Text>
              )}
            />
          </>
        </Card>
        <HideOnDesktop
          showOnTablet
          className="bg-neutral sticky bottom-0 p-4 -mx-4 mt-2 -mb-4"
        >
          <div className="w-full">
            <DataGrid
              textType="normal"
              {...{ data: stickybar }}
              repeat={5}
              nullData={() => (
                <Text severity="neutral">Not Captured</Text>
              )}
            />
          </div>
        </HideOnDesktop>
        <ModalSendEmail
          {...{
            showEmail,
            setShowEmail,
            initialEmail: customer?.contact?.email,
            SEND_EMAIL_QUERY: SEND_POLICY_EMAIL_FIRE,
            getPayLoad: (email, ccEmailIds) => {
              return {
                ...getBase64VarForFire(
                  viewProposalSF,
                  customer,
                  policy_no,
                ),
                email,
                ccEmailIds,
              };
            },
          }}
        />
        <ModalSendSms
          {...{
            showSms,
            setShowSms,
            initialMobile: customer?.contact?.mobile,
            SEND_SMS_QUERY: SEND_POLICY_SMS_FIRE,
            getPayLoad: (mobile, alternateMobileNos) => {
              return {
                ...getBase64VarForFire(
                  viewProposalSF,
                  customer,
                  policy_no,
                ),
                mobile,
                alternateMobileNos,
              };
            },
          }}
        />
      </div>
    </>
  );
}
